import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { Provider } from "react-redux";
import store from "./store";

import "@tabler/icons-webfont/dist/tabler-icons.min.css";

import { SocketProvider } from "./pages/chatWindow/contexts/SocketContext";



if (!window.nr) {
  window.nr = {
    add: () => {},
    noticeError: () => {},
    setCustomAttribute: () => {},
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <SocketProvider>
      <App />
    </SocketProvider>
  </Provider>
);



reportWebVitals();